import jeffVratanina from "../../../../assets/aboutus-assets/jeff-vratanina3.png";
import reubenmeador from "../../../../assets/aboutus-assets/reuben-Meador3.png";
import DanKanitz from "../../../../assets/aboutus-assets/Dan-Kanitz3.png";
import TiffanyGuerra from "../../../../assets/aboutus-assets/Tiffany-Guerra3.png";
import DavidAnthony from "../../../../assets/aboutus-assets/David-Anthony3.png";
import GilbertoRivas from "../../../../assets/aboutus-assets/Gilberto-Rivas3.png";
import DuncanLoughridge from "../../../../assets/aboutus-assets/Duncan-Loughridge2.png";
import AndrewKanitz from "../../../../assets/aboutus-assets/Andrew-kanitz3.png";
import belindaBentley from "../../../../assets/aboutus-assets/belinda1.png";


import Mobile from "../../../../assets/icons/mobile-icon.svg";
import Mail from "../../../../assets/icons/mail-icon.svg";
import Twitter from "../../../../assets/icons/twitter-white-icon.svg";
import Facebook from "../../../../assets/icons/facebook-white-icon.svg";
import Instagram from "../../../../assets/icons/instagram-white-icon.svg";
export const data = [
  {
    profile: jeffVratanina,
    profileName: "Jeff Vratanina",
    position: "Chairman of the Board, NEPTA | Co-Founder, MYREDFOLDER®",
    twitterlink: "https://twitter.com/neptanow",
    facebooklink: "https://www.facebook.com/nepta.us",
    instagramlink: "https://www.instagram.com/",
    twitter: Twitter,
    facebook: Facebook,
    instagram: Instagram,
    mobile: Mobile,
    mail: Mail,
    content: `<p>
<b>Jeff Vratanina</b> serves as Chairman of the Board for the National Emergency Planning and Training Association (NEPTA), a position he has held for over a decade. A seasoned entrepreneur and executive leader, Mr. Vratanina has successfully led, managed, or partnered in over a dozen businesses across the financial, technology, and emergency management sectors. His strategic vision, operational expertise, and leadership have been instrumental in NEPTA’s growth and in expanding its suite of proprietary, trademarked services.
</p>
<p>
As an early visionary and strategic partner in the founding of <b>MYREDFOLDER®</b>, Mr. Vratanina played a central role in shaping the company’s direction, ensuring its alignment with real-world emergency management needs. His contributions have been vital to the platform’s development, operational scalability, and positioning within both the public and private sectors.
</p>
<p>
With a distinguished background in mortgage banking—most notably as co-founder and Managing Director of Pinnacle Financial Corporation—Mr. Vratanina grew the firm into a national lender with over 1,200 employees, 120 branch locations, and $6.5 billion in annual originations prior to its successful acquisition in 2007. His core competencies include strategic planning, service delivery, operational efficiency, technology integration, and executive leadership.
</p>
<p>
Mr. Vratanina continues to serve as an integral member of the MYREDFOLDER, Inc. team, providing strategic guidance and ensuring the organization remains mission-driven, innovative, and positioned for sustainable growth.
</p>`,
  },
  {
    profile: reubenmeador,
    profileName: "Reuben Meador",
    position: "Executive Director, NEPTA | Founder, MYREDFOLDER®",
    twitterlink: "https://twitter.com/neptanow",
    facebooklink: "https://www.facebook.com/nepta.us",
    instagramlink: "https://www.instagram.com/",
    twitter: Twitter,
    facebook: Facebook,
    instagram: Instagram,
    mobile: Mobile,
    mail: Mail,
    content: `
<p>Reuben Meador is a recognized leader in disaster preparedness, response, and recovery, with over two decades of experience navigating complex federal, state, and local emergency management landscapes. As Managing Director of the National Emergency Planning and Training Association (NEPTA), Mr. Meador oversees multi-million-dollar disaster recovery and mitigation projects across the U.S. Virgin Islands, Puerto Rico, Florida, Louisiana, and Texas. His expertise in federal grants administration, strategic program management, and regulatory compliance positions him as a trusted advisor to government agencies, non-profits, and private sector organizations.</p>
<p>In addition to his leadership at NEPTA, Mr. Meador is the visionary founder of MYREDFOLDER®, a groundbreaking platform designed to redefine disaster readiness and personal preparedness. His innovative approach to technology-driven emergency planning solutions has led to the development of trademarked and copyrighted products and services that empower individuals, businesses, and communities to proactively manage risks and streamline crisis response.</p>
<p>A strategic thinker and respected industry expert, Mr. Meador holds multiple certifications in emergency management, disaster recovery, and grant administration. His deep understanding of public assistance programs, hazard mitigation strategies, and infrastructure resilience allows him to navigate complex funding mechanisms and deliver impactful solutions.</p>
<p>Mr. Meador’s commitment to quality, ethics, and innovation continues to drive MYREDFOLDER® and NEPTA’s success, ensuring that organizations at all levels remain prepared, resilient, and equipped to respond to any emergency.</p>  `,
  },
  {
    profile: DanKanitz,
    profileName: "Dan Kanitz",
    position: "Co-Founder, MYREDFOLDER® | Senior Program Manager / Developer  ",
    twitterlink: "https://twitter.com/neptanow",
    facebooklink: "https://www.facebook.com/nepta.us",
    instagramlink: "https://www.instagram.com/",
    twitter: Twitter,
    facebook: Facebook,
    instagram: Instagram,
    mobile: Mobile,
    mail: Mail,
    content: `<p><b>Dan Kanitz</b> is a forward-thinking leader and preparedness strategist at MYREDFOLDER®, Inc., where he plays a pivotal role in shaping the vision, development, and deployment of the MYREDFOLDER® platform. With over a decade of experience in project management, crisis response, and public safety strategy, Mr. Kanitz has successfully led complex preparedness initiatives for municipalities, major healthcare systems, and aerospace firms—translating high-risk scenarios into actionable, community-based solutions.
</p>


<p>
At MYREDFOLDER®, he oversees cross-functional development teams, guiding software engineers, emergency planners, and communications staff to align product features with real-world emergency use cases. From emergency planning to user experience optimization, Mr. Kanitz ensures that MYREDFOLDER® remains a dynamic and trusted tool for families, businesses, and institutions alike.
</p>

<p>
His passion for safety and resilience is rooted in a lifelong commitment to service and innovation. Under his leadership, the platform has expanded its capabilities to include family tracking, active shooter alerts, real-time emergency notifications, and secure document storage.  As an equity partner, he is a key driver behind MYREDFOLDER®’s integration into benefit platforms, municipal preparedness campaigns, and public-private partnerships nationwide.
</p>
<p>
Mr. Kanitz’s ability to merge technological innovation with emergency management principles makes him an indispensable force in advancing MYREDFOLDER®’s mission: empowering every household with the tools and confidence to prepare for, respond to, and recover from crisis events.
</p>
`,
  },

  {
    profile: TiffanyGuerra,
    profileName: "Tiffany Guerra",
    position: "Executive Admin",
    twitterlink: "https://twitter.com/neptanow",
    facebooklink: "https://www.facebook.com/nepta.us",
    instagramlink: "https://www.instagram.com/",
    twitter: Twitter,
    facebook: Facebook,
    instagram: Instagram,
    mobile: Mobile,
    mail: Mail,
    content: `<p><b>Tiffany Guerra</b> is a strategic leader and visionary contributor at NEPTA and MYREDFOLDER®, Inc., bringing over a decade of specialized experience in client relations, data management, systems integration, cost analysis, and cost estimation. She plays a pivotal role in advancing disaster preparedness, response, recovery, and community resilience initiatives.
</p>
<p>
Tiffany’s multidisciplinary expertise spans the development and execution of marketing strategies, software-based quality assurance, and the validation of expenses and inventory. She has successfully managed the allocation and administration of more than $98 million in federal disaster recovery and mitigation funding, demonstrating a strong command of government compliance standards and fiscal accountability.
</p>
<p>
Her in-depth knowledge of federal grant policies and regulatory frameworks—combined with her skill in designing and refining systems, procedures, and internal policies aligned with both federal requirements and the operational goals of MYREDFOLDER®—positions her as an invaluable asset in the emergency management and federal grants domain.</p>

`,
  },

  {
    profile: DavidAnthony,
    profileName: "David Anthony",
    position: "Co-Founder, MYREDFOLDER® | Senior Project Manager",
    twitterlink: "https://twitter.com/neptanow",
    facebooklink: "https://www.facebook.com/nepta.us",
    instagramlink: "https://www.instagram.com/",
    twitter: Twitter,
    facebook: Facebook,
    instagram: Instagram,
    mobile: Mobile,
    mail: Mail,
    content: `<p>
<b>Mr. David</b> serves as NEPTA’s Senior Program Administrator and Project Manager, where he leads the implementation and oversight of multiple federal programs and associated construction initiatives. With a comprehensive understanding of the Project Management Professional (PMP) lifecycle, Mr. David is responsible for managing all phases of project implementation to ensure strategic alignment with organizational goals. His role includes procuring adequate resources, managing complex portfolios that may span multiple business lines—including initiatives related to MYREDFOLDER®—and delivering projects from initiation through deployment.
</p>
<p>
Mr. David provides on-site leadership, fostering a collaborative environment where project teams are motivated to achieve milestones and uphold responsibilities. He oversees full project life cycle execution, ensuring timely delivery, quality control, and client satisfaction. His responsibilities include preparing detailed project plans, managing daily activities and resources, chairing team meetings, monitoring staff performance, and conducting performance reviews.
</p>
<p>
Additionally, Mr. David is instrumental in developing estimates, defining scopes of work, and managing vendor relationships. He reports on project metrics, monitors dependencies, identifies risks, and resolves issues, ensuring ongoing alignment between technical, operational, and business objectives. His leadership extends to establishing internal policies, templates, and best practices that strengthen organizational capabilities.
</p>
<p>
An effective communicator and problem solver, Mr. David engages with executive leadership and stakeholders to deliver clear and actionable updates. He plays a pivotal role in feasibility studies, vendor selection, negotiation, dispute resolution, and change management. He also supports formal engagement contracts, defines deliverables, and ensures adherence to budget, schedule, and quality standards.
</p>
</p>
Through executive-level communication, stakeholder engagement, team mentoring, and results-driven leadership, Mr. David ensures NEPTA’s projects and programs consistently meet or exceed performance expectations.
</p>`,
  },

  {
    profile: GilbertoRivas,
    profileName: "Gilbert Rivas",
    position: "Co-Founder, MYREDFOLDER® | Lead Project Manager",
    twitterlink: "https://twitter.com/neptanow",
    facebooklink: "https://www.facebook.com/nepta.us",
    instagramlink: "https://www.instagram.com/",
    twitter: Twitter,
    facebook: Facebook,
    instagram: Instagram,
    mobile: Mobile,
    mail: Mail,
    content: `<p>
<b>Mr. Gilbert Rivas </b> serves as a Project Manager at MYREDFOLDER®, Inc., where he oversees the successful execution of multiple initiatives tied to the program’s growth, marketing, and national expansion. With full project lifecycle ownership, Mr. Rivas leads projects from initiation through deployment, ensuring alignment with organizational goals and maintaining a strong focus on timely delivery, quality, and stakeholder satisfaction.
</p>
<p>
He provides hands-on leadership to cross-functional teams, fostering collaboration and accountability while managing daily operations, vendor relationships, budgets, and communication strategies. Mr. Rivas is instrumental in defining scopes of work, coordinating schedules, managing risks, and monitoring project performance through key metrics and milestones.
</p>
<p>
As a key contributor to MYREDFOLDER®’s strategic development, he also plays a critical role in establishing internal systems, templates, and operational best practices that support scalable growth. His ability to deliver executive-level communication, resolve complex challenges, and ensure quality control makes him a vital asset to the ongoing success and expansion of the MYREDFOLDER® platform.
</p>`,
  },

  {
    profile: DuncanLoughridge,
    profileName: "Duncan Loughridge",
    position: "Senior Program Manager",
    twitterlink: "https://twitter.com/neptanow",
    facebooklink: "https://www.facebook.com/nepta.us",
    instagramlink: "https://www.instagram.com/",
    twitter: Twitter,
    facebook: Facebook,
    instagram: Instagram,
    mobile: Mobile,
    mail: Mail,
    content:
      "Duncan G. Loughridge is a seasoned and dynamic management professional with arich background spanning over 22 years in disaster recovery, political affairs, andbusiness development. His expertise as a program manager in FEMA Public Assistancedisaster recovery is unparalleled, excelling across all categories of work whilerepresenting Applicants in their critical disaster recovery finance needs. In his current role, Duncan serves as a Senior Program Manager as well as a SeniorValidation &amp; Costing Specialist at NEPTA, where he showcases his prowess in FEMA Public Assistance, HMGP, and CDBG-DR/MIT Projects",
  },
  {
    profile: AndrewKanitz,
    profileName: "Andrew Kanitz",
    position: "Co-Founder, MYREDFOLDER® | Product Director | IoT & Digital Innovation Leader",
    twitterlink: "https://twitter.com/neptanow",
    facebooklink: "https://www.facebook.com/nepta.us",
    instagramlink: "https://www.instagram.com/",
    twitter: Twitter,
    facebook: Facebook,
    instagram: Instagram,
    mobile: Mobile,
    mail: Mail,
    content: `<P>
Andrew Kanitz is a seasoned Product Director with a proven track record of driving innovation, strategy, and user-centric design in the digital space. As a leader at MYREDFOLDER, Inc., he has played a pivotal role in advancing solutions and connected experiences, ensuring that technology enhances both safety, efficiency, and user satisfaction. His expertise in digital product management, UX design, and strategic growth has positioned him as a key innovator in the industry.
</P>
<P>
Andrew brings his extensive technical acumen and product leadership to MYREDFOLDER, Inc., where his ability to merge cutting-edge technology with seamless user experiences will be instrumental in expanding MYREDFOLDER® and its suite of products and services. His commitment to quality, safety, and ethical innovation ensures that MYREDFOLDER® continues to set new standards in digital solutions.

</P>
<P>
Core Expertise:</P>

<ul>
<li>
Product Strategy & Management – Leads cross-functional teams to develop product roadmaps, optimize UX, and drive market adoption.</li>

<li>IoT & Connected Solutions – Develops and implements smart, data-driven technologies that enhance efficiency, automation, and user engagement.</li>

<li>Storytelling & Brand Development – Crafts compelling narratives that elevate brand identity, strengthen marketing strategies, and drive customer connection.</li>

<li>Technology & UX Design – Combines a deep understanding of user behavior, interface design, and technical architecture to create seamless digital experiences.</li></ul>
<P>
Andrew's visionary leadership and passion for innovation make him a critical force in MYREDFOLDER®’s evolution, helping to shape the future of digital safety and preparedness.</P>`,
  },
  {
    profile: belindaBentley,
    profileName: "Belinda A. Bentley, Ph.D",
    position: "Director of Federal Programs, NEPTA",
    twitterlink: "https://twitter.com/neptanow",
    facebooklink: "https://www.facebook.com/nepta.us",
    instagramlink: "https://www.instagram.com/",
    twitter: Twitter,
    facebook: Facebook,
    instagram: Instagram,
    mobile: Mobile,
    mail: Mail,
    content: `<P>
The Director of Federal Programs for the National Emergency Planning and Training Association (NEPTA) serves in a key leadership role
focused on securing, managing, and overseeing federal funding, grants, and partnerships to support NEPTA’s mission of helping families,
businesses, local governments, and Indian Tribes prepare for, respond to, and recover from disasters through continuity planning, training,
mitigation, resiliency strategies, and related services (such as portable shelters, emergency operations centers, and cloud-based plan storage).
Dr. Bentley provides strategic direction in the development and management of budgets for federal programs, coordinating with NEPTA’s finance
team to allocate funds effectively across training initiatives, mitigation projects, plan development, and service delivery. In addition, Dr. Bentley
helps to foster MYREDFOLDER® partnerships with other national, state, and local emergency management organizations, as well as private
sector entities, to leverage federal programs for joint initiatives.</P>`
}
];
